import React, {Component} from 'react';
import Nav from '../../components/Nav/Nav';
import TitreH1 from '../../components/Titres/TitreH1';
import TitreH4 from '../../components/Titres/TitreH4';
import FavGames from '../FavGames/FavGames';

class Homepage extends Component {
    render() {
        return (
            <>
                <Nav><TitreH4 className="mb-0 mt-1">My Indie Games - Home</TitreH4></Nav>

                <div className="bg-single-game">
                    <img src="https://media.rawg.io/media/games/e0f/e0f05a97ff926acf4c8f43e0849b6832.jpg" alt="bg games" />   
                </div>
                
                <div className='container mt-5'>
                    <div className='row no-gutters'>
                        <div className='col-12 col-md-7'>
                            <TitreH1>Ma sélection de jeux</TitreH1>
                            <p className='w-100'>Vous trouverez ci-dessous une sélection des jeux que j'ai présenté sur TikTok et que je vous conseille donc (pour la plupart) ! Les liens d'achat et du TikTok en question sont également présents sur cette page.</p>
                        </div>
                        <div className='col-12'>
                            <FavGames />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Homepage;